var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq36(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.19844,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4348,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 39.0222,
    y1: 12.1824,
    x2: 50.2586,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.34841,
    y1: 49.8543,
    x2: 12.5847,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.7844,
    y1: 38.6199,
    x2: 50.0207,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.11057,
    y1: 0.944118,
    x2: 12.3469,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.868 22.524C18.9333 21.6747 19.26 21.0073 19.848 20.522C20.4453 20.0273 21.2153 19.78 22.158 19.78C22.7833 19.78 23.32 19.892 23.768 20.116C24.216 20.34 24.552 20.648 24.776 21.04C25.0093 21.4227 25.126 21.8567 25.126 22.342C25.126 22.93 24.9533 23.4387 24.608 23.868C24.2627 24.2973 23.7727 24.5633 23.138 24.666V24.736C23.8007 24.8667 24.328 25.156 24.72 25.604C25.112 26.0427 25.308 26.6213 25.308 27.34C25.308 28.1427 25.0373 28.8007 24.496 29.314C23.964 29.818 23.1893 30.07 22.172 30.07C21.2013 30.07 20.4033 29.818 19.778 29.314C19.1527 28.8007 18.7933 28.0773 18.7 27.144H19.652C19.736 27.7693 19.9973 28.278 20.436 28.67C20.8747 29.0527 21.4533 29.244 22.172 29.244C22.8813 29.244 23.4227 29.0573 23.796 28.684C24.1787 28.3107 24.37 27.8347 24.37 27.256C24.37 25.8373 23.348 25.128 21.304 25.128H20.996V24.302H21.318C23.222 24.302 24.174 23.6813 24.174 22.44C24.174 21.8987 23.9967 21.4647 23.642 21.138C23.2873 20.802 22.7833 20.634 22.13 20.634C21.4953 20.634 20.968 20.802 20.548 21.138C20.1373 21.4647 19.8947 21.9267 19.82 22.524H18.868ZM32.8675 22.412C32.6621 21.1987 31.9575 20.592 30.7535 20.592C29.8388 20.592 29.1528 20.9467 28.6955 21.656C28.2381 22.3653 28.0281 23.5273 28.0655 25.142C28.2521 24.582 28.6068 24.1433 29.1295 23.826C29.6615 23.4993 30.2681 23.336 30.9495 23.336C31.9295 23.336 32.7041 23.6393 33.2735 24.246C33.8521 24.8433 34.1415 25.6693 34.1415 26.724C34.1415 27.34 34.0201 27.9 33.7775 28.404C33.5441 28.8987 33.1801 29.2953 32.6855 29.594C32.2001 29.8927 31.5935 30.042 30.8655 30.042C29.4748 30.042 28.5135 29.5987 27.9815 28.712C27.4588 27.8253 27.1975 26.57 27.1975 24.946C27.1975 21.4927 28.3828 19.766 30.7535 19.766C31.6495 19.766 32.3541 20.0133 32.8675 20.508C33.3808 20.9933 33.6841 21.628 33.7775 22.412H32.8675ZM30.7675 24.176C30.3288 24.176 29.9135 24.2647 29.5215 24.442C29.1295 24.6193 28.8075 24.89 28.5555 25.254C28.3128 25.6087 28.1915 26.0473 28.1915 26.57C28.1915 27.326 28.4155 27.956 28.8635 28.46C29.3115 28.964 29.9648 29.216 30.8235 29.216C31.5421 29.216 32.1161 28.9967 32.5455 28.558C32.9748 28.1193 33.1895 27.522 33.1895 26.766C33.1895 25.954 32.9795 25.3193 32.5595 24.862C32.1395 24.4047 31.5421 24.176 30.7675 24.176Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq36);
export default __webpack_public_path__ + "static/media/fq36.8b13eea030c9209fec1a9b53946966e8.svg";
export { ForwardRef as ReactComponent };